import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { configureAtomDevtools } from '../utils/tracking';
import { createPersistedStorage } from '../utils/persistence';

const ACTIVE_TEAM_STORAGE_KEY = 'localagent-active-team';
const ACTIVE_TEAM_STORAGE_VERSION = 1;

function migrateActiveTeamId(value: unknown): string | null {
  if (typeof value === 'string') {
    return value;
  }
  return null;
}

const activeTeamIdBaseAtom = atomWithStorage<string | null>(
  ACTIVE_TEAM_STORAGE_KEY,
  null,
  createPersistedStorage<string | null>({
    version: ACTIVE_TEAM_STORAGE_VERSION,
    migrate: migrateActiveTeamId,
  })
);

/** Persistence sink for the bare `/work` landing only (app-shell ADR-010). */
export const activeTeamIdAtom = configureAtomDevtools(
  atom<string | null, [string | null], void>(
    (get) => get(activeTeamIdBaseAtom),
    (_get, set, next: string | null) => set(activeTeamIdBaseAtom, next)
  ),
  'work/activeTeamId'
);

export interface WorkItemSessionLink {
  sessionId: string;
  running: boolean;
}

const workItemSessionsBaseAtom = atom<Record<string, WorkItemSessionLink>>({});

export const workItemSessionsAtom = configureAtomDevtools(
  atom((get) => get(workItemSessionsBaseAtom)),
  'work/workItemSessions'
);

function sameLinks(
  a: Record<string, WorkItemSessionLink>,
  b: Record<string, WorkItemSessionLink>
): boolean {
  const aKeys = Object.keys(a);
  if (aKeys.length !== Object.keys(b).length) return false;
  return aKeys.every(
    (k) => b[k]?.sessionId === a[k].sessionId && b[k]?.running === a[k].running
  );
}

export const setWorkItemSessionsAction = configureAtomDevtools(
  atom(null, (get, set, next: Record<string, WorkItemSessionLink>) => {
    if (sameLinks(get(workItemSessionsBaseAtom), next)) return;
    set(workItemSessionsBaseAtom, next);
  }),
  'work/setWorkItemSessions'
);
